export const SET_ADMIN_MODE = 'action.user.set.admin.mode';
export const UPDATE_USER_DATA = 'action.user.update.data';
export const SET_API_KEY = 'action.user.set.api.key';
export const TOGGLE_TRIAL_STATUS_PANEL = 'action.user.trial-status-panel.show';
export const SET_IS_USER_SLACK_AUTH = 'action.user.set.is.user.slack.auth';

export const setAdminMode = enabled => {
    return {
        type: SET_ADMIN_MODE,
        enabled,
    };
};

export const updateUserData = data => {
    return {
        type: UPDATE_USER_DATA,
        data,
    };
};

export const setApiKey = api_key => {
    return {
        type: SET_API_KEY,
        api_key,
    };
};

export const toggleTrialStatusPanel = (show, trialRealDaysLeft, trialDaysLeftToDisplay) => {
    return {
        type: TOGGLE_TRIAL_STATUS_PANEL,
        show,
        trialRealDaysLeft,
        trialDaysLeftToDisplay,
    };
};

export const setIsUserSlackAuth = isUserSlackAuth => {
    return {
        type: SET_IS_USER_SLACK_AUTH,
        isUserSlackAuth,
    };
};
